export const SET_ALL_TA = 'SET_ALL_TA';
export const SET_ALL_DISEASES = 'SET_ALL_DISEASES';
export const DELETE_TA = 'DELETE_TA';
export const UPDATE_TA = 'UPDATE_TA';
export const ADD_TA = 'ADD_TA';
export const DELETE_DISEASE = 'DELETE_DISEASE';
export const UPDATE_DISEASE = 'UPDATE_DISEASE';
export const ADD_DISEASE = 'ADD_DISEASE';
export const SET_CURRENT_PERMISSIONS = "SET_CURRENT_PERMISSIONS";